module.exports = __webpack_public_path__ + "02_mid_black.96f8052c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_mid_black.png
// module id = pa4B
// module chunks = 0